import { Box, Button, CircularProgress, Grid } from "@mui/material";

import { DashboardCharts } from "src/components/DashboardComponents/Charts/DashboardCharts";
import { EndpointChart } from "src/components/DashboardComponents/Charts/EndpointChart";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useContext, useEffect, useState } from "react";
import { SidebarContext } from "src/contexts/SidebarContext";
import RequestsChartUsage from "src/components/DashboardComponents/Charts/RequestsChartUsage";
import RequestsChart from "src/components/DashboardComponents/Charts/RequestsChart";

function UsagePage() {
  const { remainingRequests, isDataLoaded, selectedMonth, selectedYear, handlePreviousMonth, handleNextMonth } = useContext(SidebarContext);

  console.log("selectedMonth", selectedMonth);
  console.log("selectedYear", selectedYear);
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", p: { lg: 4, xs: 3 }, pt: { lg: 1, xs: 1.5 } }}>
        <Box display="flex" justifyContent="end" pb={1}>
          <Button
            size="small"
            variant="outlined"
            color="warning"
            onClick={handlePreviousMonth}
            sx={{
              minWidth: "0px",
              p: 1,
              fontFamily: "Roboto, arial",
              borderRight: "none",
              borderRadius: "4px 0 0 4px",
              color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              borderColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
              backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
              "&:hover": {
                color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
                borderColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                borderRight: "none",
              },
            }}
          >
            <ArrowBackIosIcon sx={{ fontSize: 14 }} />
          </Button>

          <Button
            size="small"
            variant="outlined"
            color="warning"
            disabled
            sx={{
              p: 0,
              borderRadius: 0,
              fontFamily: "Roboto, arial",
              color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              borderColor: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
              "&.Mui-disabled": {
                color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                borderColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                borderLeft: "none",
                borderRight: "none",
              },
            }}
          >
            {new Date(selectedYear, selectedMonth - 1).toLocaleString("en-US", { month: "long" })}
            {/* December */}
          </Button>

          <Button
            variant="outlined"
            color="warning"
            onClick={handleNextMonth}
            sx={{
              p: 1,
              minWidth: "0px",
              fontFamily: "Roboto, arial",
              borderLeft: "none",
              borderRadius: "0 4px 4px 0",
              color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
              borderColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
              backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
              "&:hover": {
                color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
                borderColor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                borderLeft: "none",
              },
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
          </Button>
        </Box>
        <Grid container p={0} spacing={2} flexDirection="row" justifyContent={{ lg: "space-between", md: "center", xs: "center" }} alignItems="strech">
          <Grid item xs={12} lg={8} sm={8}>
            <DashboardCharts />
          </Grid>

          <Grid item xs={12} lg={4} sm={4}>
            {isDataLoaded ? (
              remainingRequests?.subscription_status === "free_tier" || remainingRequests?.subscription_status === "canceled" ? (
                <RequestsChartUsage />
              ) : (
                <RequestsChart />
              )
            ) : (
              <>
                <Box
                  sx={{
                    position: "relative",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    background: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
                    border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    borderRadius: 0.5,
                  }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <CircularProgress size={64} disableShrink thickness={3} sx={{ color: PureLightThemeCaaS.colors.alpha.orange[100] }} />
                </Box>
              </>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2} pt={2}>
          <EndpointChart />
        </Grid>
      </Box>
    </>
  );
}

export default UsagePage;
